import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { LiaClockSolid, LiaCheckCircleSolid } from "react-icons/lia";
import { useState } from 'react';
import ReportDescriptionModal from './ReportDescriptionModal';

const ReenrollmentChart = ({report}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const totalCount = report?.lines?.find(line => line.key === 'total_count')?.value || 0;
  const waitingCount = report?.lines?.find(line => line.key === 'waiting_reenrollment_count')?.value || 0;
  const completedCount = report?.lines?.find(line => line.key === 'reenrollment_count')?.value || 0;

  const data = [
    {
      name: 'Aguardando Rematrícula',
      value: parseInt(waitingCount),
      color: '#EF4444',
      icon: <LiaClockSolid className="w-4 h-4" />
    },
    {
      name: 'Rematriculados',
      value: parseInt(completedCount),
      color: '#10B981',
      icon: <LiaCheckCircleSolid className="w-4 h-4" />
    }
  ];


  const CustomLabel = ({ cx, cy }) => {
    return (
      <text 
        x={cx} 
        y={cy} 
        textAnchor="middle" 
        dominantBaseline="middle" 
        className="text-2xl font-bold fill-gray-900"
      >
        {parseInt(totalCount).toLocaleString()}
      </text>
    );
  };

  return (
    <>
      <div className='flex items-center gap-2 mb-4'>
        <LiaClockSolid className="text-xl text-blue-600" />
        <h3 className='text-lg font-semibold text-gray-900'>{report?.title || 'Rematrículas'}</h3>
        {report?.description && (
          <button
            onClick={() => setIsModalOpen(true)}
            className="w-4 h-4 bg-gray-400 rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-500 transition-colors duration-200"
          >
            <span className="text-white text-xs font-bold">?</span>
          </button>
        )}
      </div>
      
      <div className="flex flex-col items-center">
        <div className="h-72 w-72">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={50}
                outerRadius={110}
                paddingAngle={2}
                dataKey="value"
                label={CustomLabel}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
        
        {/* Chart Labels at Bottom */}
        <div className="flex justify-center gap-6 mt-4">
          {data.map((item, index) => {
            const percentage = totalCount > 0 ? ((item.value / totalCount) * 100).toFixed(1) : '0.0';
            return (
              <div key={index} className="flex items-center gap-2">
                <div 
                  className="w-3 h-3 rounded-full flex-shrink-0" 
                  style={{ backgroundColor: item.color }}
                ></div>
                <div className="text-center">
                  <p className="text-xs font-medium text-gray-600">{item.name}</p>
                  <p className="text-base font-bold text-gray-900">{item.value.toLocaleString()}</p>
                  <p className="text-xs text-gray-500">{percentage}%</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      
      <ReportDescriptionModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={report?.title || 'Rematrículas'}
        description={report?.description}
      />
    </>
  );
};

export default ReenrollmentChart;
